import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BookingReason } from '../../../domain/BookingReason'
import { richTextPlainText, truncateRichTextHtml } from '../../../utilities/rich-text'

@Component({
    selector: 'app-reason-card',
    templateUrl: './reason-card.component.html',
})
export class ReasonCardComponent {

    @Input() reason!: BookingReason
    @Input() date!: Date
    @Input() isSelected!: boolean
    @Input() isFull!: boolean
    @Input() disabledLabel: string = 'Fully booked'
    @Output() reasonSelected = new EventEmitter<void>()
    showMore: boolean = false
    characterLimit: number = 210
    protected readonly richTextPlainText = richTextPlainText
    protected readonly truncateRichTextHtml = truncateRichTextHtml
}
